import axios from 'axios'

export default {
  async getEstablishments() {
    try {
      const response = await axios.get(`/establishments`)
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return []
      } else {
        return Promise.reject(e)
      }
    }
  },
  async getEstablishment(establishmentId) {
    try {
      const response = await axios.get(`establishments/${establishmentId}`)
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return null
      } else {
        return Promise.reject(e)
      }
    }
  },
}
